export default "__VITE_ASSET__IKiVcp8B__"